/* eslint-disable */

<template>

  <div v-if="this.$store.state.fetchVereinComplete == true" class="mt-8 flex flex-wrap w-full">

    <div class="w-full md:w-1/2">

      <div class="w-full md:w-11/12 mx-auto">

        <img :src="$store.state.vereinMitglied.bild.url" alt="">

      </div>

    </div>

    <div class="w-full md:w-1/2 p-4">

      <h1 class="text-gray-800 text-4xl text-left" v-html="this.$store.state.vereinMitglied.titel"> </h1>

      <p class="pb-2" v-html="this.$store.state.vereinMitglied.text"></p>


      <div class="flex my-4">


        <button  @click="showformular()" class="bg-orange-300 hover:bg-orange-400 text-gray-800 font-bold py-4 px-4 mr-12 rounded block text-black">

          <span> Anmeldeformular</span>

        </button>

        <a target="_blank" href="https://weissenburgbad.ch/wordpress/wp-content/uploads/2020/08/Anmeldeformular.pdf">
          <button class=" hover:bg-orange-300 text-gray-800 font-bold py-4 px-4 rounded block border-4 border-orange-300">
            <span>PDF Formular</span>
          </button>
        </a>

      </div>

      <div v-if="this.showform" class="mt-8">
        <!-- FORMULAR -->
        <form class="text-left" action="index.html" method="post">

          <div class="">

            <h2 class="mb-0 text-gray-800 text-3xl text-left">Anmeldeformular</h2>
            <p>Vereinsmitgliedschaft</p>

            <div class="bg-gray-200 p-4 rounded w-full sm:w-2/3 mb-2">

              <div class="flex items-center mr-4 mb-4">
                <input v-model="radio" value="Einzelmitglied" id="radio1" type="radio" name="radio" class="hidden" />
                <label for="radio1" class="flex items-center cursor-pointer text-base">
                  <span class="w-8 h-8 inline-block mr-2 rounded-full border-2 border-gray-800 flex-no-shrink"></span>
                  Einzelmitglied CHF 40 / Jahr</label>
                </div>

                <div class="flex items-center mr-4 mb-4">
                  <input v-model="radio" value="Ehepaar" id="radio2" type="radio" name="radio" class="hidden" />
                  <label for="radio2" class="flex items-center cursor-pointer text-base">
                    <span class="w-8 h-8 inline-block mr-2 rounded-full border-2 border-gray-800 flex-no-shrink"></span>
                    Ehepaar CHF 50 / Jahr</label>
                  </div>

                  <div class="flex items-center mr-4 mb-4">
                    <input v-model="radio" value="Jur.Person" id="radio3" type="radio" name="radio" class="hidden" />
                    <label for="radio3" class="flex items-center cursor-pointer text-base">
                      <span class="w-8 h-8 inline-block mr-2 rounded-full border-2 border-gray-800 flex-no-shrink"></span>
                      Jur. Person CHF 90 / Jahr</label>
                    </div>

                    <div class="flex items-center mr-4 mb-4">
                      <input v-model="radio" value="Gönner" id="radio4" type="radio" name="radio" class="hidden" />
                      <label for="radio4" class="flex items-center cursor-pointer text-base">
                        <span class="w-8 h-8 inline-block mr-2 rounded-full border-2 border-gray-800 flex-no-shrink"></span>
                        Gönner CHF 40 / Jahr</label>
                      </div>

                    </div>
                  </div>

                  <div class="mb-2 w-full sm:w-2/3">
                    <label class="text-base text-gray-00">Name</label>
                    <input data-vv-name="Name" v-validate="'required'" v-model="name" class="w-full px-5 py-1 text-gray-700 bg-gray-200 rounded" type="text" required="" placeholder="Max Mustermann">
                    <p class="text-xs text-red-800">{{ errors.first('Name') }}</p>
                  </div>

                  <div class="mb-2 w-full sm:w-2/3">
                    <label class="block text-base text-gray-00">Adresse</label>
                    <input data-vv-name="Adresse" v-validate="'required'" v-model="adress" class="w-full px-5 py-1 text-gray-700 bg-gray-200 rounded" type="text" required="" placeholder="Bunschenmattli, 3765 Oberwil i/S">
                    <p class="text-xs text-red-800">{{ errors.first('Adresse') }}</p>
                  </div>

                  <div class="mb-2 w-full sm:w-2/3">
                    <label class="block text-base text-gray-00">E-Mail</label>
                    <input data-vv-name="Email" v-validate="'required|email'" v-model="email" class="w-full px-5 py-1 text-gray-700 bg-gray-200 rounded" placeholder="max@muster.ch">
                    <p class="text-xs text-red-800">{{ errors.first('Email') }}</p>
                  </div>

                  <div class=" mb-2 w-full sm:w-2/3">
                    <label class=" block text-base text-gray-00">Telefon</label>
                    <input data-vv-name="Telefonnummer" v-validate="'required'" v-model="phone" class="w-full px-5 py-1 text-gray-700 bg-gray-200 rounded" placeholder="079 123 45 67">
                    <p class="text-xs text-red-800">{{ errors.first('Telefonnummer') }}</p>
                  </div>

                </form>

                <div class="flex mt-8">

                  <button v-if="isFormInvalid" @click="showmessage()" class="bg-orange-300 text-gray-800 font-bold py-4 px-4 mr-12 rounded block text-black">

                    <span> Abschicken</span>

                  </button>

                  <button v-if="!isFormInvalid" @click="sendform()" class="bg-orange-300 hover:bg-orange-400 text-gray-800 font-bold py-4 px-4 mr-12 rounded block text-black">

                    <span> Abschicken</span>

                  </button>

                </div>

                <p class="text-xs mt-2 text-red-500" v-if="message"> Bitte füllen Sie das Formular aus.</p>
                <p class="text-xs mt-2 text-blue-500" v-if="success"> Vielen Dank! Das Formular wurde abgeschickt.</p>

              </div>

            </div>

          </div>
        </template>

        <script>
        // import { ValidationProvider, extend } from 'vee-validate';

        export default {
          components: {
            // ValidationProvider

          },
          name: 'VereinMitglied',
          props: {


          },
          data() {
            return {

              radio: 1,
              name: '',
              adress: '',
              email: '',
              phone: '',
              message: false,
              success: false,
              showform: false,


            }
          },
          methods: {

            showformular(){

              this.showform = !this.showform;
            },

            showmessage(){

              this.message = true;

            },

            sendform(){

              let formData = new FormData();
              formData.append('radio', this.radio);
              formData.append('name', this.name);
              formData.append('adress', this.adress);
              formData.append('email', this.email);
              formData.append('phone', this.phone);

              axios({
                method: 'post',
                url: 'https://weissenburgbad.ch/php/member.php',
                data: formData,
                config: { headers: {'Content-Type': 'multipart/form-data' }},
              })
              .then( response => {

                // console.log(response.data);

                if (response.data == true){

                  this.success = true;

                }

              })
              .catch(function (response) {
                //handle error
                alert("Uh! Da ist etwas schief gelaufen")
                // console.log(response)
              });

            },

            compare(a, b) {
              if (a.text < b.text) {
                return -1;
              }
              if (a.text > b.text) {
                return 1;
              }
              // a muss gleich b sein
              return 0;
            },


          },
          mounted: function(){

          },

          computed: {

            isFormInvalid() {
              return Object.keys(this.fields).some(key => this.fields[key].invalid);
            },

            sortDownloads() {
              // console.log(this.data.slice().sort(this.compare));

              return this.$store.state.downloads.slice().sort(this.compare);
            },

            sortVerein() {
              // console.log(this.data.slice().sort(this.compare));

              var result = this.$store.state.verein.filter(obj => {
                return obj.id === 1;
              })

              // console.log(result);

              return result
            },

          },
        }
        </script>

        <!-- Add "scoped" attribute to limit CSS to this component only -->
        <style scoped lang="scss">

        #map{
          height: 100%;
          width: 50%;

        }

        button{
          // display: block;

        }

        // input[type="radio"] + label span {
        //   transition: background .2s,
        //   transform .2s;
        // }

        // input[type="radio"] + label span:hover,
        // input[type="radio"] + label:hover span{
        //   transform: scale(1.2);
        // }

        input[type="radio"]:checked + label span {
          background-color: #4195D0; //bg-blue
          box-shadow: 0px 0px 0px 2px white inset;
        }

        input[type="radio"]:checked + label{
          color: #4195D0; //text-blue
        }

        </style>
